export type NonsoleReadinessServiceErrorCode =
  | 'report_timeout'
  | 'report_failed'
  | 'report_malformed'
  | 'entry_timeout'
  | 'entry_malformed'
  | 'service_destroyed';

export class NonsoleReadinessServiceError extends Error {
  readonly serviceCode: NonsoleReadinessServiceErrorCode;
  readonly nativeError?: string;

  constructor(
    serviceCode: NonsoleReadinessServiceErrorCode,
    message: string,
    options?: { nativeError?: string; cause?: unknown },
  ) {
    super(message, options?.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = 'NonsoleReadinessServiceError';
    this.serviceCode = serviceCode;
    this.nativeError = options?.nativeError;
  }
}

export function isNonsoleReadinessServiceError(err: unknown): err is NonsoleReadinessServiceError {
  return err instanceof NonsoleReadinessServiceError;
}
